import React from "react";

const PhoneNumberFormatter = phoneNumber => {
	return <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
};

export default PhoneNumberFormatter;
